export default __webpack_public_path__ + "static/media/banner3.ce93e7b0.jpg";